export default {
  setApp (state, payload) {
    state.app = payload
  },
  setLastestVersion (state, payload) {
    state.lastestVersion = payload
  }
}